import React from 'react';
import clsx from 'clsx';

import { type FieldProps } from '@/stories/components/Form/Input/Input';
import { Icon, type IconType } from '@/stories/atoms/Icon/Icon';
import styles from './toggle.module.css'
import { Count } from '@/stories/atoms/Count/Count';

export type ToggleProps = React.ComponentProps<'input'> & Omit<FieldProps, "label"> & {
  label?: string | React.ReactElement,
  icon?: IconType,
  count?: number
}

export const Toggle = ({label, icon, id, name, value, count, required = false, variant, ...props}: ToggleProps) => {

  return (
    <label htmlFor={id} className={clsx(styles.label, variant && styles[variant], count === 0 && styles.disabled)}>
      <input type='checkbox' id={id || name} value={value} {...props} required={required} className={styles.input}/>
      {icon ? <Icon icon={icon} size={'xl'}/> : null}
      {label}
      {count ? <Count value={count}/> : null}
    </label>
  )
};
